import { HttpRequest, HttpHandler, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ServerErrorService } from '../server-error/server-error.service';
import { ModalService, ErrorModalComponent, ErrorModalData } from '@schenck/rotec-components';

/**
 * Handle server errors
 */
@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  private readonly modalService = inject(ModalService);
  private readonly serverErrorService = inject(ServerErrorService);

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    return next.handle(request).pipe(
      tap({
        next: () => null,
        error: (error: HttpErrorResponse) => {
          // Is server sends back unhandled error
          if (error.status >= 500) {
            this.serverErrorService.setServerError(true);
            this.modalService.open(ErrorModalComponent, <ErrorModalData>{
              text: 'Please contact your IT department or the Schenck digital support if this problem persists.',
              additionalText:
                'You can return to the application by clicking the Close button and retry your actions.',
              title: 'Service currently not available.',
            });
          }
        },
      })
    );
  }
}
